// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__k2qND","light":"tag_light__BYs0z","clickable":"tag_clickable__lYbby"};